var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(!_vm.$store.state.isLoggedIn)?_c('h4',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t("logout.label"))+" "),_c('br'),_c('router-link',{attrs:{"to":"/home"}},[_vm._v(" "+_vm._s(_vm.$t("logout.link"))+" ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }